// extracted by mini-css-extract-plugin
export default {"melodyCardCategory":"qX-z","categoryName":"rX-z","categoryImage":"sX-z","categoryContent":"tX-z","bottomAligned":"uX-z"};